export const PRICE_LOGIN_REQUIRED_TRIGGER_ID = 'price-login-required-trigger'
export const SCROLL_AFTER_LOGIN_KEY = 'priceConfigurator.scrollAfterLogin'
export const CONFIGURATOR_STATE_KEY = 'priceConfigurator.configuratorState'
